import { Book } from '@/data/books';
import { BookCard } from './BookCard';

interface BookGridProps {
  books: Book[];
  columns?: 2 | 3 | 4;
}

export function BookGrid({ books, columns = 4 }: BookGridProps) {
  const gridClass = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
  }[columns];

  return (
    <div className={`grid ${gridClass} gap-4 md:gap-6`}>
      {books.map((book, index) => (
        <div
          key={book.id}
          className="animate-fade-in"
          style={{ animationDelay: `${index * 0.05}s` }}
        >
          <BookCard book={book} />
        </div>
      ))}
    </div>
  );
}
